import { createRef, useEffect } from "react";
import PropTypes from "prop-types";
import { transformHtml } from "../../utils/CmsUtils";

function TrustpilotWidget(props) {
  const containerRef = createRef();

  useEffect(() => {
    if (window.Trustpilot) {
      const trustPilotElement = containerRef.current.children[0];
      if (trustPilotElement) {
        window.Trustpilot.loadFromElement(trustPilotElement);
      }
    } else {
      const script = document.createElement("script");
      script.src =
        "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      document.body.appendChild(script);
    }
  });
  return (
    <div ref={containerRef} className={"trustpilot-widget-container"}>
      {transformHtml(props.code)}
    </div>
  );
}

TrustpilotWidget.propTypes = {
  code: PropTypes.string.isRequired
};

export default TrustpilotWidget;
